var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"score"},[(Number(_vm.rankNum))?_c('span',{staticClass:"rank star"},[_vm._v("x"+_vm._s(_vm.rankNum))]):_vm._e(),_c('span',{staticClass:"rank thumb"},[_vm._v(_vm._s(_vm.thumb))])])}
var staticRenderFns = []

export { render, staticRenderFns }